import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const NOTE_KEY = "note:spike";

export const useJourneyCampaigns = (API, clientId) => {
  const [months, setMonths] = useState({});
  const [notes, setNotes] = useState({});

  const load = useCallback(() => {
    if (!API || !clientId) return;
    axios.get(`${API}/journey-campaigns`, { params: { client_id: clientId } })
      .then((r) => { setMonths(r.data?.months || {}); setNotes(r.data?.notes || {}); })
      .catch(() => { setMonths({}); setNotes({}); });
  }, [API, clientId]);

  useEffect(() => { load(); }, [load]);

  const save = async (body, msg) => {
    try {
      await axios.put(`${API}/journey-campaigns`, { client_id: clientId, ...body });
      toast.success(msg);
      load();
    } catch {
      toast.error("Couldn't save");
    }
  };

  const remove = async (month, key, msg = "Removed") => {
    try {
      await axios.delete(`${API}/journey-campaigns`, { params: { client_id: clientId, month, key } });
      toast.success(msg);
      load();
    } catch {
      toast.error("Couldn't remove");
    }
  };

  return {
    months,
    notes,
    rename: (month, key, name) => save({ month, key, name }, "Renamed"),
    toggleHidden: (month, key, hidden) => save({ month, key, hidden }, hidden ? "Hidden from client" : "Shown to client"),
    add: (month, name, channel) => save({ month, name, channel }, "Campaign added"),
    remove,
    saveNote: (month, text) => save({ month, key: NOTE_KEY, name: text, hidden: false }, "Saved"),
    clearNote: (month) => save({ month, key: NOTE_KEY, name: "", hidden: true }, "Hidden from client"),
    resetNote: (month) => remove(month, NOTE_KEY, "Back to the auto sentence"),
  };
};
